import { Link } from "@StarberryUtils";
import { useStaticQuery, graphql } from "gatsby";
import React,{useEffect, useState} from "react";
import {Col, Row, Container } from 'react-bootstrap';
//import ScrollAnimation from 'react-animate-on-scroll';
import { useQuery } from '@apollo/client';
import gql from "graphql-tag"
import person from "../../../images/no-person.jpg"

import { MEET_THE_TEAM_PAGE_URL, CONTACT_PAGE_URL } from "../../common/site/constants";

const NegotiatorDetails = (props) => {

	
	const data = useStaticQuery(graphql`
	query{
	  strapidata {
		  people {
			Name
			Tile_Image {
			  url
			}
			Designation
			URL
			Phone
			Embed_Video_URL
			Negotiator_ID
			Upload_Video {
			  url
			}
			Category {
			  Name
			  URL
			}
			Offices {
			  URL
			}
			imagetransforms
			id
		  }
		  offices {
			id
			Name
			Phone
			Email
			Address
			URL
			Sales_CRM_ID
			Lettings_CRM_ID
			New_Homes_CRM_ID
		  }
	  }
	}
  `);
  

	const officeID = props?.office_id;

	const foundItem = data.strapidata?.offices.filter(item =>
		item.Sales_CRM_ID === officeID || item.Lettings_CRM_ID === officeID || item.New_Homes_CRM_ID === officeID
	  );

	const foundPersonItem = data.strapidata?.people.filter(item =>
		item.Negotiator_ID === props.data.ID
	  );


	var officedata = foundItem && foundItem.length > 0 ? foundItem[0] : ''
	var persondata = foundPersonItem && foundPersonItem.length > 0 ? foundPersonItem[0] : ''
	  
	return (
		<div className="adviser-quote text-left">
            <h3 className="adviser-title">Speak to your Property Adviser</h3>
            <div className="adviser-profile d-flex align-items-center">
                <figure><img loading="lazy" src={persondata ? persondata?.Tile_Image?.url : person} alt="profile-img" /></figure>
                <div className="prof-info">
                    {persondata ? <Link to={`${MEET_THE_TEAM_PAGE_URL.alias}/${persondata ? persondata?.URL : ''}`} className="neg-name"><span className="name">{persondata.Name}</span></Link> : <span className="name">{props.data.Name}</span> }

					{persondata?.Phone && (
					<a href={"tel:" + persondata.Phone.replace(/\D/g, '')}>
						{persondata.Phone}
					</a>
					)}					
            	</div>			
       		</div>
			<div className="office-contact-data">
				<div className="office-info">
					{officedata ? 
					   <Link to={`${CONTACT_PAGE_URL.alias}/${officedata ? officedata?.URL : ''}`} className="office-name"><span className="name">Martyn Gerrard {officedata.Name} Office</span></Link> : "" }
						{officedata?.Address && <p className="office-address">{officedata.Address}</p> }
				</div>
			</div>
		</div>
	)
}

export default NegotiatorDetails